import React, {useEffect, useRef, useState} from "react";
import {injectIntl} from "react-intl";
import View from "./View";

function WorldChatPopUp({
  intl,
  sendWorldMessage,
  onChangeChatMode,
  onClickChatOption,
}) {
  const inputRef = useRef(null);
  const MAX_LENGTH = 50;
  const [currentValue, setCurrentValue] = useState("");
  const [currentColor, setCurrentColor] = useState(null);

  useEffect(() => {
    return () => onChangeChatMode(false);
  }, [onChangeChatMode]);

  const onChange = () => {
    if (!inputRef.current) return;
    const value = inputRef.current.value;
    if (getByteCount(value) > MAX_LENGTH) return;
    setCurrentValue(value);
  };

  const onClickColor = color => {
    setCurrentColor(color);
  };

  const onClickSubmit = () => {
    if (currentValue.trim().length === 0) return;
    if (!currentColor) return;
    sendWorldMessage(currentValue, currentColor);
    onClickClose();
  };

  const onClickClose = () => {
    onClickChatOption(null);
  };

  const getByteCount = text => {
    let byte = 0;
    for (let i = 0; i < text.length; i++) {
      if (/[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(text[i])) {
        byte += 2;
      } else {
        byte++;
      }
    }
    return byte;
  };

  return (
    <View
      intl={intl}
      inputRef={inputRef}
      currentValue={currentValue}
      currentColor={currentColor}
      MAX_LENGTH={MAX_LENGTH}
      getByteCount={getByteCount}
      onChange={onChange}
      onClickColor={onClickColor}
      onClickSubmit={onClickSubmit}
      onChangeChatMode={onChangeChatMode}
      onClickClose={onClickClose}
    />
  );
}

export default injectIntl(WorldChatPopUp);
